/*
 * EditControl Messages
 *
 * This contains all the text for the EditControl component.
 */

import { defineMessages } from 'react-intl';

export default defineMessages({
  header: {
    id: 'app.components.SaveModal.header',
    defaultMessage: 'Save Route',
  },
  title: {
    id: 'app.components.SaveModal.title',
    defaultMessage: 'Name for this route',
  },
  description: {
    id: 'app.components.SaveModal.description',
    defaultMessage: 'Description',
  },
  city: {
    id: 'app.components.SaveModal.city',
    defaultMessage: 'City',
  },
  province: {
    id: 'app.components.SaveModal.province',
    defaultMessage: 'State/Province',
  },
  country: {
    id: 'app.components.SaveModal.country',
    defaultMessage: 'Country',
  },
  isPublic: {
    id: 'app.components.SaveModal.isPublic',
    defaultMessage: 'Public (route is visible to others)',
  },
  replace: {
    id: 'app.components.SaveModal.replace',
    defaultMessage: 'Replace existing route',
  },
  createNew: {
    id: 'app.components.SaveModal.createNew',
    defaultMessage: 'Create new route',
  },
});
